 import React from "react";
import "./Animaldetail.css";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import lionImg from "../../assets/1.jpg"; 
import leopardImg from "../../assets/leopard.jpg";
import rhinoImg from "../../assets/rhino.jpg";
import elephantImg from "../../assets/elephant.jpg";
import buffaloImg from "../../assets/buffaloImg.jpg";

const animals = [
  {
    id: 1,
    name: "Lion",
    scientific: "Panthera leo",
    image: lionImg,
    status: "Vulnerable",
    habitat: "Grasslands and Savannas",
    diet: "Carnivore",
    population: "20,000",
    threat: "Habitat Loss, Hunting and Climate Change",
    about: "Lions are social big cats that live in groups called prides. They are powerful predators and play an important role in maintaining the balance of ecosystems.",
    fact: "A lion's roar can be heard up to 8 kilometers away."
  },
  {
    id: 2,
    name: "Leopard",
    scientific: "Panthera pardus",
    image: leopardImg,
    status: "Near Threatened",
    habitat: "Forests, Mountains and Grasslands",
    diet: "Carnivore",
    population: "700,000",
    threat: "Habitat Loss and Poaching",
    about: "Leopards are highly adaptable animals. They are excellent climbers and can survive in many environments.",
    fact: "Leopards often carry their prey onto trees."
  },
  {
    id: 3,
    name: "Rhino",
    scientific: "Rhinocerotidae",
    image: rhinoImg,
    status: "Critically Endangered",
    habitat: "Grasslands and Tropical Forests",
    diet: "Herbivore",
    population: "27,000",
    threat: "Illegal Horn Trade",
    about: "Rhinos are large herbivores known for their horns and thick skin. They are among the oldest mammals on Earth.",
    fact: "Rhinos can run faster than many people expect."
  },
  {
    id: 4,
    name: "Elephant",
    scientific: "Loxodonta",
    image: elephantImg,
    status: "Endangered",
    habitat: "Savannas, Forests and Wetlands",
    diet: "Herbivore",
    population: "415,000",
    threat: "Poaching and Habitat Loss",
    about: "Elephants are the largest land mammals. They are intelligent, social and have excellent memory.",
    fact: "Elephants communicate through vibrations and sounds."
  },
  {
    id: 5,
    name: "Buffalo",
    scientific: "Syncerus caffer",
    image: buffaloImg,
    status: "Least Concern",
    habitat: "Grasslands and Woodlands",
    diet: "Herbivore",
    population: "900,000",
    threat: "Disease and Habitat Loss",
    about: "African buffaloes are powerful animals that live in large herds and protect one another.",
    fact: "Buffaloes are known for their teamwork and defense."
  }
];

function AnimalDetails() {
  return (
    <div className="animal-detail-page">
      <Navbar />

      <section className="hero">
        <div className="hero-overlay">
          <h1>Wildlife Animal Encyclopedia</h1>
          <p>Explore amazing wildlife species and discover their habitat, diet, threats and conservation.</p>
        </div>
      </section>

      <div className="container">
        {animals.map((animal) => (
          <div className="animal-box" key={animal.id}>
            <div className="left">
              <img src={animal.image} alt={animal.name} />
            </div>
            <div className="right">
              <h1>{animal.name}</h1>
              <h3>Scientific Name: {animal.scientific}</h3>
              <span className="status">{animal.status}</span>
              <h2>About</h2>
              <p>{animal.about}</p>
              <h2>Habitat</h2>
              <p>{animal.habitat}</p>
              <h2>Diet</h2>
              <p>{animal.diet}</p>
              <h2>Population</h2>
              <p>{animal.population}</p>
              <h2>Threats</h2>
              <p>{animal.threat}</p>
              <h2>Interesting Fact</h2>
              <p>{animal.fact}</p>
            </div>
          </div>
        ))}
      </div>

      <section className="conservation">
        <h1>Conservation Efforts</h1>
        <div className="con-box">
          <div className="c-card">Protected Areas</div>
          <div className="c-card">National Parks</div>
          <div className="c-card">Wildlife Sanctuaries</div>
          <div className="c-card">Awareness Programs</div>
        </div>
      </section>

      <section className="gallery">
        <h1>Wildlife Gallery</h1>
        <div className="gallery-grid">
          <img src={lionImg} alt="lion" />
          <img src={leopardImg} alt="leopard" />
          <img src={rhinoImg} alt="rhino" />
          <img src={elephantImg} alt="elephant" />
          <img src={buffaloImg} alt="buffalo" />
        </div>
      </section>

      <section className="cta">
        <h1>Protect Wildlife Today</h1>
        <p>Join us in preserving wildlife and protecting nature for future generations.</p>
        <button>Donate Now</button>
      </section>

      <Footer />
    </div>
  );
}
 
export default AnimalDetails;